import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PublicScanScore } from '@brand24-original/llm-types';
import ReportSection from './ReportSection';
import './ReportSummary.scss';
import { brandLabel } from './brandLabel';

interface ReportSummaryProps {
  brand: string;
  score: PublicScanScore;
}

export const ReportSummary: React.FC<ReportSummaryProps> = ({ brand, score }) => {
  const { t } = useTranslation();

  const position = score.averagePosition;
  const tiles = [
    { label: t('visibility'), value: `${score.visibility}%` },
    { label: t('shareOfVoice'), value: `${score.shareOfVoice}%` },
    // Panel pokazuje wynik marki jako liczbę całkowitą (`Math.round` w `ProjectStatsTiles`),
    // choć liczy go z jednym miejscem po przecinku — raport ma pokazywać dokładnie to samo.
    { label: t('brandScore'), value: `${Math.round(score.brandScore)}%` },
    {
      label: t('averagePosition'),
      value: position === null ? '-' : `#${position}`,
    },
  ];

  return (
    <ReportSection
      title={t('reportSummaryTitle')}
      titleAccent={t('reportSummaryTitleAccent')}
      subtitle={t('reportSummarySubtitle', {
        brand: brandLabel(brand),
        visibility: score.visibility,
        share: score.shareOfVoice,
      })}
    >
      <div className="report-summary__tiles">
        {tiles.map((tile) => (
          <div key={tile.label} className="report-summary__tile">
            <span className="report-summary__tile-value">{tile.value}</span>
            <span className="report-summary__tile-label">{tile.label}</span>
          </div>
        ))}
      </div>
    </ReportSection>
  );
};

export default ReportSummary;
